<template>
  <PageTemplate>
    <h1>Notifications</h1>
    <v-card-body>
      <strong v-if="length === 0">
        There are no unread notifications!
      </strong>
      <v-button-group
        v-if="length > 0"
        is-right
      >
        <v-button
          color="transparent"
          @click="removeAll()"
        >
          <v-icon type="trash" />
          Clear all notifications
        </v-button>
      </v-button-group>
      <v-notification
        v-for="(notification) in notifications"
        :key="notification.id"
        :title="notification.data.title"
        :date="notification.date"
        :is-unread="!notification.read_at"
        :type="notification.data.data.type"
        @read="resolveNotification(notification)"
        @delete="remove(notification.id)"
      />
      <v-button-group is-right>
        <v-button
          v-if="total > count"
          color="transparent"
          @click="showNextTwenty()"
        >
          Show older notifications
        </v-button>
      </v-button-group>
    </v-card-body>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "../templates/Page";
  import {mapState} from "vuex";
  import Notification from "@/molecules/Notification";
  import Icon from "@/atoms/Icon";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import CardBody from "@/atoms/CardBody";
  import {notificationResolver, getNotifications, performNotificationAction} from "@/common/notificationUtils";
  import {formatDate} from "@/common/formatting";
  import routes from "@/common/routes";
  import {
    GET_USER_NOTIFICATION,
  } from "@/store/actions.type";

  export default {
    name: "Job",
    components: {
      "v-notification": Notification,
      "v-icon": Icon,
      "v-button": Button,
      "v-button-group": ButtonGroup,
      "v-card-body": CardBody,
      PageTemplate,
    },
    data() {
      return {
        currentPage: 1,
        pageCount: 0,
        count: 20,
      };
    },
    computed: {
      ...mapState({
        notifications: state => state.notification.notifications,
        length: state => state.notification.length,
        total: state => state.notification.total
      }),
    },
    watch: {
      count: {
        handler: function (val, oldVal) {
          this.$store.dispatch(GET_USER_NOTIFICATION, this.count)
        }
      }
    },
    mounted() {
      this.updateBreadCrumb();
      getNotifications();
    },
    methods: {
      removeAll() {
        var ids = []
        for (let [key, value] of Object.entries(this.notifications)) {
          ids.push(value.id)
        }
        this.update(ids, 'delete');
      },
      remove(id) {
        let ids = []
        ids.push(id);
        this.update(id, 'delete');
      },
      resolveNotification(notification) {
          notificationResolver(notification);
      },
      updateBreadCrumb: function () {
        this.$store.dispatch('updateBreadCrumbAction', [{
          name: 'Dashboard',
          link: routes.DASHBOARD
        }, {name: 'Notifications'}]);
      },
      showNextTwenty() {
        this.count = this.count + 20;
      },
      update(ids, type) {
        performNotificationAction(ids, type, this.count);
      }
    },
  }
</script>

